/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantAccountData
 */
export interface GoogleMerchantAccountData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    parentAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    accountType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantAccountData
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    discoveredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    timeZone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantAccountData
     */
    languageCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleMerchantAccountData
     */
    testAccount?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleMerchantAccountData
     */
    marketCountryCodes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleMerchantAccountData
     */
    marketCategoryIds?: Array<string>;
    /**
     * 
     * @type {GoogleMerchantAccountDataMarketGranularityEnum}
     * @memberof GoogleMerchantAccountData
     */
    marketGranularity?: GoogleMerchantAccountDataMarketGranularityEnum;
    /**
     * 
     * @type {number}
     * @memberof GoogleMerchantAccountData
     */
    competitiveWindowDays?: number;
}


/**
 * @export
 */
export const GoogleMerchantAccountDataMarketGranularityEnum = {
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
} as const;
export type GoogleMerchantAccountDataMarketGranularityEnum = typeof GoogleMerchantAccountDataMarketGranularityEnum[keyof typeof GoogleMerchantAccountDataMarketGranularityEnum];


/**
 * Check if a given object implements the GoogleMerchantAccountData interface.
 */
export function instanceOfGoogleMerchantAccountData(value: object): value is GoogleMerchantAccountData {
    return true;
}

export function GoogleMerchantAccountDataFromJSON(json: any): GoogleMerchantAccountData {
    return GoogleMerchantAccountDataFromJSONTyped(json, false);
}

export function GoogleMerchantAccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantAccountData {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'parentAccountId': json['parentAccountId'] === undefined ? undefined : json['parentAccountId'] === null ? null : json['parentAccountId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'accountType': json['accountType'] == null ? undefined : json['accountType'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : json['discoveredAt'],
        'timeZone': json['timeZone'] === undefined ? undefined : json['timeZone'] === null ? null : json['timeZone'],
        'languageCode': json['languageCode'] === undefined ? undefined : json['languageCode'] === null ? null : json['languageCode'],
        'testAccount': json['testAccount'] == null ? undefined : json['testAccount'],
        'marketCountryCodes': json['marketCountryCodes'] == null ? undefined : json['marketCountryCodes'],
        'marketCategoryIds': json['marketCategoryIds'] == null ? undefined : json['marketCategoryIds'],
        'marketGranularity': json['marketGranularity'] == null ? undefined : json['marketGranularity'],
        'competitiveWindowDays': json['competitiveWindowDays'] == null ? undefined : json['competitiveWindowDays'],
    };
}

export function GoogleMerchantAccountDataToJSON(json: any): GoogleMerchantAccountData {
    return GoogleMerchantAccountDataToJSONTyped(json, false);
}

export function GoogleMerchantAccountDataToJSONTyped(value?: GoogleMerchantAccountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'parentAccountId': value['parentAccountId'],
        'displayName': value['displayName'],
        'accountType': value['accountType'],
        'enabled': value['enabled'],
        'discoveredAt': value['discoveredAt'],
        'timeZone': value['timeZone'],
        'languageCode': value['languageCode'],
        'testAccount': value['testAccount'],
        'marketCountryCodes': value['marketCountryCodes'],
        'marketCategoryIds': value['marketCategoryIds'],
        'marketGranularity': value['marketGranularity'],
        'competitiveWindowDays': value['competitiveWindowDays'],
    };
}

